import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import ProfilePhoto from "../../../components/common/ProfilePhoto";


function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  // fieldValue is column value
  // row is whole row object
  // rowIdx is index of row
  // colIdx is index of column
  if (row.empStatus == "P")
    return 'color5';
  else if (row.empStatus == "R")
    return 'color2';
  else
    return 'td-column-function-odd-example';
}

class TeamTable extends React.Component {


  constructor() {
    super();
    this.state = {checked: false};
  }

  renderShowsTotal(start, to, total) {
    return (

      <p style={ {marginTop: '10px', color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  render() {
    return (
      <div>
        <BootstrapTable height="550"
                        search={true}
                        options={ {noDataText: '...', paginationShowsTotal: this.renderShowsTotal} }
                        containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
                        headerStyle={{
                          borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px',
                          borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
                        }}
                        tableStyle={{marginBottom: '5%', borderStyle: 'solid'}}

                        pagination={true}
                        data={this.props.teamEmployee} striped={false} hover={true} condensed={true}>
          <TableHead


            width={160} dataField="name"
            dataFormat={(cell, row)=> {
              return <ProfilePhoto empno={row.empId} height="150px" width="160px"/>

            }
            }>Photo</TableHead>
          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat}
                     isKey={true}
                     hidden={true}
                     width={70}
                     dataField="empId">Id</TableHead>
          <TableHead dataSort={true}
                     filter={ {type: 'TextFilter', placeholder: 'Name'} }
                     columnClassName={ columnClassNameFormat}
                     width={110} dataField="fullName"
                     dataFormat={(cell, row)=> {
                       return <a onClick={()=> {
                         this.props.showEmployee(row.empId);
                       }}
                       >{row.empId}<br/><br/>{cell}</a>
                     }
                     }>Name</TableHead>


          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat}
                     dataFormat={this.checkNull}
                     width={150}
                     filter={ {type: 'TextFilter', placeholder: 'Email Id'} }
                     dataField="officeEmailId">Email Id</TableHead>

          <TableHead dataField="contactNo"
                     columnClassName={ columnClassNameFormat}
                     dataFormat={this.checkNull}
                     dataSort={true}
                     width={100}>Phone no</TableHead>
          <TableHead dataField="department"
                     columnClassName={ columnClassNameFormat}
                     dataFormat={this.checkNull}
                     dataSort={true}
                     filter={ {type: 'TextFilter', placeholder: 'Department'} }
                     width={100}>Department</TableHead>
          <TableHead dataField="designation"
                     columnClassName={ columnClassNameFormat}
                     dataFormat={this.checkNull}
                     dataSort={true}
                     filter={ {type: 'TextFilter', placeholder: 'Designation'} }
                     width={120}>Designation</TableHead>
          <TableHead dataField="officeLocation"
                     dataFormat={this.checkNull}
                     dataSort={true}
                     filter={ {type: 'TextFilter', placeholder: 'Location'} }
                     columnClassName={ columnClassNameFormat}
                     width={120}>Location</TableHead>
          <TableHead dataField="reportingTo"
                     dataFormat={this.checkNull}
                     dataSort={true}
                     filter={ {type: 'TextFilter', placeholder: 'Manager'} }
                     columnClassName={ columnClassNameFormat}
                     width={120}>Manager</TableHead>

          <TableHead dataField="officeLocation"
                     columnClassName="paddingNone"
                     dataFormat={(cell, row)=> {
                       let absentDayCount = row.absentDayCount;
                       if (row.empStatus == "P")
                         return <div style={{padding: 0}}>
                           <ul>
                             <li><a onClick={()=> {
                               this.props.showEmployee(row.empId);
                             }}>View More</a></li>
                             <li><p style={{color: "red"}}>Exit Request has been raised</p></li>
                           </ul>
                           <br/>
                         </div>
                       else if (row.empStatus == "R") {
                         return <div>
                           <ul>
                             <li><a onClick={()=> {
                               this.props.showEmployee(row.empId);
                             }}>View More</a><br/></li>
                             <li><a onClick={()=> {
                               this.props.viewExit(row.empId);
                             }}>View Exit Details</a><br/></li>

                           </ul>
                         </div>
                       }
                       else if(absentDayCount>=3){

                        return <div style={{padding: 0}}>
                          <ul>
                            <li><a onClick={()=> {
                              this.props.showEmployee(row.empId);
                              }}>View More</a><br/>
                            </li>
                            <li><a onClick={()=> {
                              this.props.showExit(row.empId);
                              }}>Move to Exit</a>
                            </li>
                            <li><a onClick={()=> {
                              this.props.moveToAbscond(row.empId);
                            }}>Move to Abscond</a>
                            </li>
                          </ul>
                        </div>
                       }
                       else
                         return <div style={{padding: 0}}>
                           <ul>
                             <li><a onClick={()=> {
                               this.props.showEmployee(row.empId);
                             }}>View More</a><br/></li>

                             <li><a onClick={()=> {
                               this.props.showExit(row.empId);
                             }}>Move to Exit</a></li>
                           </ul>
                         </div>
                     }}
                     width={120}>Actions</TableHead>


        </BootstrapTable>
      </div>
    );
  }
}

TeamTable.propTypes = {};

export default TeamTable;





/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/ManagerSS/TeamTable.js
 **/